export default __webpack_public_path__ + "static/media/Hypertension-2.aada34aa.jpg";